import FullPageLoading from "components/Layouts/FullPageLoading"
import { useEffect } from "react"
import { REDIRECT_URL_PARAM, useLoginNativeApp } from "./hooks"
import { isAndroidWebView, isIOSWebView } from "utils/webViewDetection"
import { useSetPageTitle } from "libs/ga"
import { notifyFoodMountedToApp } from "utils/nativeAppHelper"
import { useAppSelector } from "app/hooks"
import { Navigate, useSearchParams } from "react-router-dom"
import PATHS from "router/paths"

const LoginInNativeApp = () => {
  const isIOS = isIOSWebView()
  const isAndroid = isAndroidWebView()
  const appName = isIOS ? "iOS" : isAndroid ? "Android" : "Web"

  useSetPageTitle(`Login in ${appName} app`)

  const { handleLoginInNativeApp } = useLoginNativeApp()

  useEffect(() => {
    ;(window as any).handleLoginInNativeApp = handleLoginInNativeApp
    notifyFoodMountedToApp()
  }, [])

  return <FullPageLoading />
}

const LoginInNativeAppGuard = () => {
  const [params] = useSearchParams()
  const token = useAppSelector((state) => state.auth.token)
  const redirectUrl = params.get(REDIRECT_URL_PARAM) || PATHS.app.root

  if (token) {
    return <Navigate to={redirectUrl} />
  }

  return <LoginInNativeApp />
}

export default LoginInNativeAppGuard
